import {LovListSummary} from "./LovListSummary.model";
import {WithSummaryModel} from "../../../../entity/dto/plain/withSummary.model";

export class LovListModel implements WithSummaryModel<LovListSummary> {
    summary: LovListSummary;
}